const en = {
  nav: {
    services: 'Services',
    work: 'Work',
    results: 'Results',
    contact: 'Contact',
  },
  hero: {
    eyebrow: 'Senior Software Engineer',
    headlinePart1: 'From fragmented systems to a',
    headlinePart2: 'unified platform.',
    description:
      'I help mid-size and enterprise companies modernize legacy platforms, connect fragmented systems, and build software that scales with their business.',
    cta: 'Schedule a Discovery Call',
    tags: ['Java / Spring', 'AWS', 'React', 'Microservices', 'AI Integration'],
  },
  about: {
    title: 'My Advantage',
    description:
      'Senior Full Stack Developer with experience across telecommunications, consulting, manufacturing, finance, municipal services and business automation.',
    yearsLabel: 'Years of Experience',
    effortLabel: 'Manual Effort Reduced',
  },
  pain: {
    label: 'Sound familiar?',
    title: 'Does this sound familiar?',
    items: [
      'Our systems don\'t talk to each other — the team works around it every day.',
      'We have legacy software that nobody wants to touch.',
      'We do things manually that should have been automated years ago.',
      'We want to leverage AI but don\'t know where to start.',
    ],
  },
  services: {
    sectionLabel: 'Solutions',
    sectionTitle: 'What I Deliver',
    learnMore: 'Learn more',
  },
  projects: {
    sectionTitle: 'Recent Work.',
    sectionDescription:
      'Real systems designed and delivered for business operations, municipal services, finance, retail automation and healthcare.',
    previousLabel: 'Previous project',
    nextLabel: 'Next project',
  },
  projectModal: {
    projectSuffix: 'Project',
    typeLabel: 'Type',
    roleLabel: 'Role',
    roleValue: 'Solution Design & Development',
    deliveryLabel: 'Delivery',
    deliveryValue: 'Static portfolio summary',
    focusLabel: 'Focus',
    focusValue: 'Business Automation',
    stackLabel: 'Stack',
    strategyTitle: 'Project Strategy',
    strategyText:
      'The goal was to replace manual processes with a focused software platform that makes daily operations easier to control, measure and scale.',
    strategyItems: [
      'Centralize operational data and reduce duplicated manual work.',
      'Provide role-based workflows for the people running the business.',
      'Generate useful reports for follow-up and decision making.',
      'Keep the solution maintainable and adaptable for future changes.',
    ],
    quote:
      'Useful software should make the operation clearer, faster and easier to audit without adding unnecessary complexity.',
    roleTitle: 'Software Engineer',
    approachTitle: 'Engineering Approach',
    approachText:
      'I focus on clear modules, reliable persistence, useful reporting, simple user flows and practical integrations with the devices or services required by the business.',
    goalsTitle: 'Project Goals',
    goalItems: [
      'Digitize core business operations.',
      'Improve traceability and reporting.',
      'Reduce manual control and spreadsheet dependency.',
      'Support daily users with practical screens and workflows.',
    ],
    resultsTitle: 'Results',
    resultItems: [
      'Operational modules tailored to the business domain.',
      'Reports and exports for management visibility.',
      'Reusable foundation for future feature growth.',
      'Better control over users, records and transactions.',
    ],
    relatedTitle: 'Related Projects',
    contactTitle: "Have a project in mind? Let's discuss",
    contactText: 'Get in touch to see how I can help you with your project.',
  },
  results: {
    label: 'Proven track record',
    title: 'Results that speak for themselves',
    context:
      '10+ years delivering production software across telecom, consulting, manufacturing, finance, and municipal services.',
    stats: [
      { value: 70, suffix: '%', label: 'Manual effort reduced' },
      { value: 40, suffix: '%', label: 'Faster deployments' },
      { value: 60, suffix: '%', label: 'Less processing time' },
      { value: 6,  suffix: '+', label: 'Industries served' },
    ],
  },
  caseStudies: {
    label: 'Selected work',
    title: 'Work',
    items: [
      {
        id: '1',
        industry: 'Insurance / Consulting',
        title: 'Aflac EverWell Platform',
        summary: 'Mission-critical enrollment platform used by Aflac agents nationwide.',
        result: '12 features delivered · 70% manual work eliminated · 40% query improvement',
      },
      {
        id: '2',
        industry: 'Manufacturing',
        title: 'AWS Cloud Migration',
        summary: 'Modernized 4 legacy applications and built 6 microservices on AWS ECS.',
        result: '4 apps migrated · 6 microservices deployed · 40% faster deployments',
      },
      {
        id: '3',
        industry: 'Telecom',
        title: 'Java Device Sales Platform',
        summary: 'Device sales and shipping system used by sales staff across the country.',
        result: '25+ features delivered · 60% invoice time reduced · team of 3 led',
      },
    ],
  },
  experience: {
    sectionTitle: 'My Work Experience',
    details: 'Details',
    keyContributions: 'Key Contributions',
  },
  contact: {
    sectionLabel: "Let's talk",
    sectionTitle: 'Ready to talk about your systems?',
    formTitle: 'Tell me about the challenge',
    subtext: "Tell me about the challenge. I'll come back with a clear picture of what's possible.",
    location: 'Morelos, Mexico',
    email: 'Emmanuel-Merida@outlook.com',
    network: 'LinkedIn',
    locationLabel: 'Location',
    emailLabel: 'Professional Email',
    networkLabel: 'Professional Network',
  },
  form: {
    namePlaceholder: 'Your Name',
    companyPlaceholder: 'Your Company',
    emailPlaceholder: 'Your Email',
    messagePlaceholder: 'Message',
    serviceDefault: 'Choose a Service',
    serviceOptions: [
      'Systems Integration',
      'Platform Modernization',
      'Business Automation',
      'AI Integration',
    ],
    submitBtn: 'Send Message',
    sending: 'Sending message...',
    successMsg: 'Thanks, your message was sent.',
    errorMsg: 'The message could not be sent. Please try again or email me directly.',
    validationMsg: 'Please complete the required fields.',
  },
  blog: {
    sectionTitle: 'Professional Insights',
    sectionDescription:
      'Ideas around software delivery, business automation, cloud platforms and applied AI.',
    essayLabel: 'Essay',
    postDetails: 'Post Details',
  },
  footer: {
    bio: 'Senior Software Engineer specializing in platform modernization, systems integration, and AI for mid-size and enterprise companies.',
    navigation: 'Navigation',
    allServices: 'Services',
    contact: 'Contact',
    footerContactDesc:
      'For consulting, custom software or senior engineering opportunities, send me an email.',
    links: {
      services: 'Services',
      work: 'Work',
      results: 'Results',
      contact: 'Contact',
    },
    services: [
      'Systems Integration',
      'Platform Modernization',
      'Business Automation',
      'AI Integration',
    ],
    emailSending: 'Sending...',
    emailSent: 'Email sent.',
    emailError: 'Could not send.',
    copyright: 'Copyright © 2026 Emmanuel Mérida Toledo. All rights reserved.',
  },
  cta: {
    title: 'Need a reliable engineering partner for your next platform?',
    button: 'Schedule a Call',
  },
  modal: {
    solutionLabel: 'Solution',
    typicalResult: 'Typical result',
    cta: 'Schedule a Call →',
    tabOverview: 'Overview',
    tabProcess: 'Process',
    tabCapabilities: 'Capabilities',
    approachHeading: 'My approach',
    workProcessHeading: 'Work Process',
    capabilitiesHeading: 'What I deliver',
    visualEyebrow: 'Service profile',
    visualTitle: 'Practical software capabilities',
    visualItems: ['Architecture', 'Automation', 'Data', 'AI'],
  },
  servicesData: [
    {
      id: '1',
      stat: { value: '70%', label: 'Reduction in manual effort' },
      title: 'Systems Integration',
      description:
        'Connect your platforms, APIs, and data sources so your operations run as one.',
      des2: 'I design integration layers that make your existing systems communicate cleanly.',
      des3: 'Typical deliverables: API gateways, event-driven flows, data pipelines, and middleware.',
      mainDescription:
        'Your systems were built at different times, by different teams. They hold the same data in three places and none of them agree. I design integration layers that eliminate that friction.',
      scopeDescription:
        'Integration work covers API design and documentation, service-to-service communication, data mapping, authentication between systems, and ongoing monitoring.',
      capabilities: [
        'REST API design and contract documentation.',
        'Event-driven integration with Kafka or RabbitMQ.',
        'Data synchronization and conflict resolution.',
        'Authentication and authorization across services.',
        'Observability and integration monitoring.',
      ],
      capabilitiesDescription:
        'Every integration project delivers clean contracts, tested communication paths, and the observability to catch issues before they affect operations.',
      approach:
        'I start by mapping your current data flows and identifying where information gets lost or duplicated. Then I design the integration layer to fix root causes, not symptoms.',
      workProcess: [
        'Map existing systems and identify integration points.',
        'Design API contracts and data models.',
        'Build and test integration paths.',
        'Deploy with monitoring and document for your team.',
      ],
    },
    {
      id: '2',
      stat: { value: '40%', label: 'Faster deployments' },
      title: 'Platform Modernization',
      description:
        'Migrate legacy software to cloud-ready architecture — without shutting down your business.',
      des2: 'I help teams modernize platforms that have become too expensive or risky to maintain.',
      des3: 'Experience includes AWS ECS, microservices, Docker, CI/CD pipelines, and incremental migrations.',
      mainDescription:
        'Legacy platforms slow you down, cost more to maintain, and break at the worst moments. I help you modernize incrementally — keeping the system running while replacing what needs replacing.',
      scopeDescription:
        'Modernization engagements cover architecture assessment, service decomposition, containerization, cloud deployment, CI/CD pipeline setup, and team knowledge transfer.',
      capabilities: [
        'Architecture assessment and migration roadmap.',
        'Service decomposition and microservices design.',
        'Docker containerization and Kubernetes orchestration.',
        'AWS deployment: ECS, RDS, Lambda, S3.',
        'CI/CD pipelines and infrastructure as code.',
      ],
      capabilitiesDescription:
        'Modernization projects deliver a phased plan, incremental migrations that keep production stable, and a cloud-ready platform your team can maintain.',
      approach:
        'I assess your current platform, identify the highest-risk areas, and design an incremental migration plan. No big-bang rewrites — each phase delivers working software.',
      workProcess: [
        'Assess current architecture and define migration scope.',
        'Design target architecture and deployment model.',
        'Migrate incrementally, phase by phase.',
        'Validate behavior and hand off to your team.',
      ],
    },
    {
      id: '3',
      stat: { value: '70%', label: 'Reduction in manual effort' },
      title: 'Business Automation',
      description:
        'Eliminate manual processes and repetitive tasks with intelligent, reliable workflows.',
      des2: 'I build automation tools that replace repetitive manual work with systems that run themselves.',
      des3: 'Examples: PDF reports, Excel exports, cash control, scheduling workflows, document generation.',
      mainDescription:
        'Manual processes cost more than you think. I map your workflows, identify what can be automated, and build systems that handle the repetitive work reliably.',
      scopeDescription:
        'Automation projects involve process mapping, workflow engine design, report generation, system integrations, and user training.',
      capabilities: [
        'Workflow engine design and implementation.',
        'Automated document and report generation.',
        'Cash control and financial reconciliation.',
        'Inventory and asset lifecycle tracking.',
        'Hardware integration: biometrics, RFID, barcodes.',
      ],
      capabilitiesDescription:
        'Automation solutions eliminate manual data entry, reduce errors, and give your team real-time visibility into business processes.',
      approach:
        'I document your current process to find the highest-cost manual steps, then build automation that replaces them. Results are measurable from day one.',
      workProcess: [
        'Map current workflows and identify bottlenecks.',
        'Design automated workflow and data model.',
        'Build and test with real business data.',
        'Train users and monitor for optimizations.',
      ],
    },
    {
      id: '4',
      stat: { value: '60%', label: 'Less processing time' },
      title: 'AI Integration',
      description:
        'Add practical AI capabilities to your existing operations. No hype, just usable results.',
      des2: 'I prototype and deploy AI tools that solve specific business problems, not demos.',
      des3: 'Work includes LLM integration, NLP pipelines, classification models, and data workflows.',
      mainDescription:
        'AI works when it solves a specific, well-defined problem in your operations. I help you find those problems, build solutions, and integrate them with your existing systems.',
      scopeDescription:
        'AI projects cover use case identification, model selection or development, prompt engineering, LLM API integration, data preprocessing, and production deployment.',
      capabilities: [
        'LLM integration with OpenAI and similar APIs.',
        'Natural language processing and text analysis.',
        'Classification, clustering, and anomaly detection.',
        'Data preprocessing and feature engineering.',
        'Model integration into production systems.',
      ],
      capabilitiesDescription:
        'AI deliverables are production-ready tools with clear accuracy metrics, integration code, and documentation for ongoing maintenance.',
      approach:
        'I start with your data and a specific business question. Then build, validate, and integrate — keeping the focus on practical results over academic perfection.',
      workProcess: [
        'Identify the business problem and define success criteria.',
        'Explore data and select or build the right model.',
        'Validate performance on real data.',
        'Integrate into production and monitor.',
      ],
    },
  ],
  blogsData: [
    {
      id: '1',
      title:
        'Vision Transformers in Computer Vision: Recent Advances, Challenges, and Future Directions',
      description:
        'A survey on Vision Transformer research from 2023 to 2026, covering efficient architectures, hybrid CNN-ViT models, self-supervised learning, interpretability, scalability and deployment challenges.',
      comment: 'Paper',
      authorTitle: 'Advanced Machine Learning Methods',
      create_at: 'March 2026',
    },
    {
      id: '5',
      title: 'Essay on Challenges and Trends in Autonomous Vehicles',
      description:
        'This essay explores the current challenges and future trends in the development of autonomous vehicles, addressing technological, regulatory, ethical and safety aspects that impact the adoption of this innovative technology.',
      comment: 'Essay',
      authorTitle: 'Author',
      create_at: 'May, 2026',
    },
  ],
  projectsData: [
    {
      id: '1',
      title: 'Gym Management System',
      subTitle: 'Java Desktop / Biometrics / POS',
      description:
        'A production-ready desktop platform for gym operations, memberships, front desk sales, inventory, shifts, cash control and biometric check-in.',
      stack: 'Java Swing, MySQL, JasperReports, Digital Persona SDK',
    },
    {
      id: '2',
      title: 'MAGNO Financial System',
      subTitle: 'Finance / Responsive Web Platform',
      description:
        'A financial operations platform for loans, collections, renewals, customers, branches, cash closing, expenses, roles and reports.',
      stack: 'Responsive web architecture, role-based access, branches, reporting',
    },
    {
      id: '3',
      title: 'Property Tax Collection System',
      subTitle: 'Municipal Government / Tax Platform',
      description:
        'A municipal property tax system for property records, taxpayer data, fiscal configuration, discounts, receipts, debt notices and cash reports.',
      stack: 'Property records, PDF receipts, Excel exports, fiscal configuration',
    },
    {
      id: '4',
      title: 'Automated Laundry System',
      subTitle: 'RFID / Arduino / Retail Automation',
      description:
        'A self-service laundry platform that connects customer RFID cards with washers and dryers while centralizing sales, inventory, shifts and reporting.',
      stack: 'RFID cards, Arduino devices, ticket printers, Windows desktop',
    },
    {
      id: '5',
      title: 'Dental Clinic Management System',
      subTitle: 'Healthcare / Patient Records',
      description:
        'A clinic system for complete patient files, contact data, allergies, treatments, costs, clinical history tracking and patient reports.',
      stack: 'Patient files, treatment history, clinical reports',
    },
  ],
  experienceData: [
    {
      id: 1,
      position: 'Senior Consultant',
      summary:
        'Contributed to EverWell, a mission-critical platform used by Aflac agents for enrollment and insurance product offerings.',
      highlights: [
        'Delivered 12+ new features following Scrum methodology.',
        'Automated MySQL processes and reduced manual work by 70%.',
        'Improved key query performance by up to 40%.',
        'Coordinated production deployments with zero critical incidents.',
      ],
    },
    {
      id: 2,
      position: 'Sr Software Engineer',
      summary:
        'Worked on Farelogix Pad, a middleware platform handling transactions between airlines and the Expedia ecosystem.',
      highlights: [
        'Refactored critical service logic and increased test coverage by 30%.',
        'Implemented airline-based configuration segmentation using YAML files.',
        'Reduced incident response times during Support Weeks.',
        'Designed new airline operations for smoother integrations.',
      ],
    },
    {
      id: 3,
      position: 'Software Engineer',
      summary:
        'Built cloud and automation solutions to optimize manufacturing processes and modernize legacy applications.',
      highlights: [
        'Migrated 4 legacy applications to AWS, reducing deployment times by at least 40%.',
        'Designed and implemented 6+ microservices deployed to AWS ECS.',
        'Built supplier notification workflows and daily batch processes.',
        'Improved API performance by up to 35% through service and SQL refactoring.',
      ],
    },
    {
      id: 4,
      position: 'Senior Software Engineer',
      summary:
        'Participated in the design and development of a legal administration system for property acquisition and branch-opening workflows.',
      highlights: [
        'Implemented 10+ REST endpoints for legal process automation.',
        'Built reusable frontend components that reduced development time.',
        'Modeled the SQL Server database from scratch.',
        'Integrated Camunda to standardize internal legal workflows.',
      ],
    },
    {
      id: 5,
      position: 'Senior Java Developer',
      summary:
        'Developed and maintained device sales and shipping systems used by sales staff nationwide.',
      highlights: [
        'Delivered 25+ features for ASD and related internal systems.',
        'Led a team of 3 developers for functional and technical delivery.',
        'Reduced invoice processing time by over 60% with a custom production support tool.',
        'Supported secure releases and vulnerability reduction with FindBugs and SonarQube.',
      ],
    },
    {
      id: 6,
      position: 'Java Developer',
      summary:
        'Provided support and refactoring for internal applications used by call center teams.',
      highlights: [
        'Refactored a legacy Java 1.5 system to Java 1.7.',
        'Improved system performance by 40%.',
        'Developed features for the Extranet system used by customer service agents.',
        'Fixed 15+ QA issues to stabilize continuous operations.',
      ],
    },
  ],
};

export default en;
